var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":_vm.jwtTest}},[_vm._v("JWT Test")])
}
var staticRenderFns = []

export { render, staticRenderFns }